import {Base} from "@/api/Base"

export class PayModeAdd extends Base {
    path = "payMode/add"
}